import React, { useState } from 'react'
import Typography from 'housecall-ui/dist/DesignSystem/DataDisplay/Typography/Typography'
import Grid from 'housecall-ui/dist/DesignSystem/Layout/Grid/Grid.js'
import Estimate from 'housecall-ui/dist/IconsAndImages/Icons/Estimate'
import ConfirmationDialog from 'housecall-ui/dist/DesignSystem/Feedback/Dialog/ConfirmationDialog'
import Button from 'housecall-ui/dist/DesignSystem/Inputs/Buttons/Button'
import CardButton from 'housecall-ui/dist/DesignSystem/Inputs/Buttons/CardButton'
import VideocamOutlined from 'housecall-ui/dist/IconsAndImages/Icons/VideocamOutlined'

const AddEstimateDialog = ({ open, onClose, handleChooseEstimateType }) => {
  const [submitting, setSubmitting] = useState(false)

  const estimateButton = (isVirtual) => (
    <CardButton
      onClick={() => {
        setSubmitting(true)
        handleChooseEstimateType(isVirtual)
      }}
      disabled={submitting}
    >
      <Grid container spacing={16}>
        <Grid item xs={12}>
          <Typography align="center" variant="caption" color="textSecondary">
            {isVirtual ? <VideocamOutlined /> : <Estimate />}
          </Typography>
        </Grid>
        <Grid item xs={12}>
          <Typography align="center" variant="body1">
            {isVirtual ? 'Virtual estimate' : 'In-person estimate'}
          </Typography>
        </Grid>
      </Grid>
    </CardButton>
  )

  return (
    <ConfirmationDialog
      title="Choose estimate type"
      open={open}
      onClose={onClose}
      rightButton={
        <Button color="secondary" onClick={onClose}>
          Cancel
        </Button>
      }
    >
      <Grid container justify="center" spacing={16}>
        <Grid item xs={5}>
          {estimateButton(false)}
        </Grid>
        <Grid item xs={5}>
          {estimateButton(true)}
        </Grid>
      </Grid>
    </ConfirmationDialog>
  )
}


export default AddEstimateDialog
